const action = "WORKSPACE_DELETE";
export const REQUEST = action+'_REQUEST';
export const RESPONSE = action+'_RESPONSE';
export const CLEAR = action+'_CLEAR';
export const FAILURE = action+'_FAILURE';

// Surfaced when the BE rejects /workspace/{id} with HTTP 409
// because the workspace still has marketplace listings with active
// subscribers. The dialog reads ``marketplaceConflict`` to render
// the cascade-confirm UI.
export const MARKETPLACE_CONFLICT = action + '_MARKETPLACE_CONFLICT';
export const MARKETPLACE_CONFLICT_CLEAR =
  action + '_MARKETPLACE_CONFLICT_CLEAR';

export const fetchRequest = (workspaceId, force = false) => {
    return {
        type: REQUEST,
        workspaceId,
        force,
    };
};

export const fetchSuccess = (response) => ({
  type: RESPONSE,
  payload: response
});

export const clearState = (response) => ({
  type: CLEAR
});

export const fetchFailure = (error) => ({
  type: FAILURE,
  payload: error
});

export const marketplaceConflict = (payload) => ({
  type: MARKETPLACE_CONFLICT,
  payload,
});

export const clearMarketplaceConflict = () => ({
  type: MARKETPLACE_CONFLICT_CLEAR,
});
